module.exports = __webpack_public_path__ + "media/images/emblems/Buelach-blazon-66fca777cb0e4faa88bfce853cb69281.svg";